module.exports = __webpack_public_path__ + "cd7d06e051460fadf82d701410955977.woff";